const colors = {
  primary: "#05152B",
  secondary: "#376BAE",
  indigo: {
    25: "#F4F5FF",
    50: "#DDDFFF",
    100: "#C6CAFF",
    200: "#A3A9FF",
    300: "#7F86FF",
    400: "#6E74FF",
    500: "#636DD3",
    600: "#4D57B9",
    700: "#3A4399",
    800: "#2A3273",
    900: "#1C224D",
  },
  error: {
    25: "#FFF5F4",
    50: "#FFDCDA",
    100: "#FFC5C1",
    300: "#FF7A72",
    400: "#FF574D",
    500: "#FF3838",
    600: "#E62E2E",
    700: "#B32424",
    800: "#BE170C",
  },
  "blaze-orange": {
    25: "#FFF4ED",
    50: "#FFE6D9",
    100: "#FFD1B8",
    200: "#FFB58A",
    300: "#FF8A59",
    400: "#FF7A4D",
    500: "#FF5B04",
    600: "#E64A00",
    700: "#B33A00",
    800: "#802900",
    900: "#4D1900",
  },
  cyan: {
    25: "#F2FCFD",
    50: "#D9F5F7",
    100: "#B3EBEF",
    200: "#80DEE4",
    300: "#4DD0D8",
    400: "#26C3CC",
    500: "#22BFCE",
    600: "#1B99A3",
    700: "#146E73",
    800: "#0E484B",
    900: "#092526",
  },
  orange: {
    25: "#FFF6ED",
    50: "#FFEBD8",
    100: "#FFD7B3",
    200: "#FFBF80",
    300: "#FFAA4D",
    400: "#FC8E28",
    500: "#EB7101",
    600: "#C55601",
    700: "#8F3A01",
    800: "#5E2601",
    900: "#331301",
  },
  purple: {
    25: "#F5ECFE",
    50: "#E2C7FC",
    100: "#CDA1FA",
    200: "#B57AF8",
    300: "#9E52F6",
    400: "#9631F5",
    500: "#820BF4",
    600: "#5E14B3",
    700: "#430D80",
    800: "#2D0750",
    900: "#1A0326",
  },
  fuchsia: {
    25: "#F5ECFE",
    50: "#F3D2FF",
    100: "#EFA1FF",
    200: "#E581F4",
    300: "#DD5CE3",
    400: "#D63ED1",
    500: "#C61AC0",
    600: "#AF11C7",
    700: "#730D66",
    800: "#4B0740",
    900: "#26021A",
  },
  sky: {
    25: "#F2F5FF",
    50: "#E8EDFF",
    100: "#B4C4FF",
    200: "#8FA1FF",
    300: "#6A7EFF",
    400: "#4A72FF",
    500: "#1B4DFF",
    600: "#3A57D8",
    700: "#2B3A9E",
    800: "#1E2673",
    900: "#12144D",
  },
  success: {
    25: "#F2FFF9",
    50: "#D7FFEB",
    100: "#A6FFD1",
    200: "#6AFFB0",
    300: "#32FF91",
    400: "#11A75C",
    500: "#42B250",
    600: "#368C40",
    700: "#255E2C",
    800: "#183A1C",
    900: "#0D1F0F",
  },
  yellow: {
    25: "#FFF9DF",
    50: "#FFF2C4",
    100: "#FFEB99",
    200: "#FFE176",
    300: "#FFD54D",
    400: "#FFCD1A",
    500: "#FFC700",
    600: "#D8A800",
    700: "#B18A00",
    800: "#8A6B00",
    900: "#664E00",
  },
  gray: {
    2: "#050505",
    4: "#242424",
    24: "#3D3D3D",
    30: "#4D4D4D",
    40: "#666666",
    48: "#7A7A7A",
    50: "#808080",
    60: "#999999",
    70: "#B3B3B3",
    80: "#CCCCCC",
    82: "#D1D1D1",
    88: "#E0E0E0",
    90: "#E6E6E6",
    94: "#F0F0F0",
    96: "#F5F5F5",
    98: "#FAFAFA",
    99: "#FCFCFC",

    25: "#F4F5F6",
    100: "#C9CDD3",
    400: "#88909F",
    500: "#727C8D",
    600: "#606977",
    700: "#4F5662",
    800: "#343A40",
    900: "#1A1D21",
  },
  slate: {
    25: "#F9FAFB",
    50: "#F3F4F6",
    100: "#E9EFF6",
    200: "#D7DFE9",
    300: "#AFBACA",
    400: "#8897AE",
    500: "#5E718D",
    600: "#455468",
    700: "#3D4A5C",
    800: "#2D3643",
    900: "#1A202E",
  },
} as const;

export default colors;
